import type { LinkCompType } from './navUtils'

const ITEMS = [
  {
    label: 'Parents',
    url: 'parents/signup',
    className: 'nav-cta-signup--parents',
  },
  {
    label: 'Schools',
    url: 'schools/signup',
    className: 'nav-cta-signup--schools',
  },
  {
    label: 'Homeschoolers',
    url: 'homeschool/signup',
    className: 'nav-cta-signup--homeschool',
  },
]

export function CtaDropdown({ LinkComp }: { LinkComp: LinkCompType }) {
  return (
    <div className="absolute right-0 top-full z-10 w-full drop-shadow-lg">
      <div className="absolute right-0 top-0 z-10 flex h-3.5 w-full items-end justify-center">
        <svg
          className="h-3.5 w-6"
          viewBox="0 0 24 12"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <clipPath id="triangle-clip">
              <rect x="0" y="0" width="24" height="11" />
            </clipPath>
          </defs>
          <g clipPath="url(#triangle-clip)">
            <polygon points="12,1 23,11 1,11" className="fill-white" />
            <path
              d="M12,1 L23,11 M12,1 L1,11"
              className="stroke-neutral-300"
              strokeWidth="1"
              strokeLinecap="square"
            />
          </g>
        </svg>
      </div>
      {/* Panel */}
      <div className="absolute right-0 top-0 mt-[11px] rounded-md border border-neutral-300 bg-white py-2">
        <ul className="font-display text-lg tracking-[.02em] text-black">
          {ITEMS.map((item) => (
            <li key={item.label}>
              <LinkComp
                href={item.url}
                className={`${item.className} mx-2 block rounded-md px-3 py-2 leading-none transition-colors duration-150 hover:bg-[var(--nav-accent-10)] active:bg-[var(--nav-accent-10)]`}
              >
                {item.label}
              </LinkComp>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
